import React from 'react'
import { Typography, Box } from '@mui/material'

const AssessmentManagementPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Assessment Management
      </Typography>
      <Typography variant="body1">
        This page will allow course creators to manage assessments and questions.
      </Typography>
    </Box>
  )
}

export default AssessmentManagementPage
